import { createContext, useContext } from 'react'

const GridFilterRowContext = createContext<HTMLDivElement | null>(null)

export function useGridFilterRowContainer() {
  return useContext(GridFilterRowContext)
}

export default GridFilterRowContext
